import React, { useEffect, useMemo, useRef, useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { Modal } from 'antd-mobile';
import { router, withRouter } from 'umi';
import { connect } from 'dva';
import QRCode from 'qrcode.react';
import { unionFlag, getSessonStorage, setCookie, throttle, debounce, checkUnifyShop, judgeTodayPopup } from '@/utils';
import OrderHead from '@/components/OrderHead';
import DfModal from '@/components/Modal';
import Api from '@/common/api';


import { Toast, Button } from 'antd-mobile';
import DfPrice from '@/components/dFPrice';
import { toPrice } from '@/utils/price';
import { getMovieSessionInfoStr, distanceNow } from '@/utils/time';
import useInterval from '@/hooks/useInterval';
import styles from './index.less';
import arrowLeft from '@/assets/imgs/arrow-left.png';
import arrowRight from '@/assets/imgs/arrow-right.png';
import refundTags from '@/assets/imgs/orderDetail/refund_tags.png';
import refundTagsEn from '@/assets/imgs/orderDetail/refund_tags_en.png';
import refundRightArrow from '@/assets/imgs/order/order_right_arrow.png';
import closeimg from '@/assets/imgs/close.png';
import os_cancel_img from '@/assets/imgs/status_cancel.png';
import os_needpay_img from '@/assets/imgs/status_needpay.png';
import os_paysucc_img from '@/assets/imgs/status_pay_succ.png';
import os_ticketsucc_img from '@/assets/imgs/status_ticket_succ.png';
import os_ticketing_img from '@/assets/imgs/status_ticketing.png';
import os_ticket_refundfailed_img from '@/assets/imgs/status_refund_failed.png';
import os_ticketing_refundsucc_img from '@/assets/imgs/status_refund_succ.png';
import cancelImg from '@/assets/imgs/icon-cancel.png';
import { ReplaceText, TLang, CheckCN, getCookie } from '@/utils/lang';
import { gioClick } from '@/utils/gioApi';
import homeReq from '@/entity/module/home/homeAPi';

const currentPageName = '订单详情页';
const serviceIcon = require('@/assets/imgs/headicon/text_service.png');
const text_serviceen = require('@/assets/imgs/headicon/text_serviceen.png');
// const tickets =[
//   {
//     ticketCode:"1103 0001 7801",
//     ticketQrCode:"http://localhost:8090/images/qr1.png"
//   },
//   {
//     ticketCode:"1103 0001 7802",
//     ticketQrCode:"http://localhost:8090/images/qr2.png"
//   },
//   {
//     ticketCode:"1103 0001 7803",
//     ticketQrCode:"http://localhost:8090/images/qr3.png"
//   }
// ]

// 0 未知，1 未确认，2 支付失败，3待支付，4已支付，5出票中，6出票成功，7出票失败，8 已取消(用户手动)
//,9申请退款，10退款成功, 11 已取消（支付超时）, 12 退款失败，13 退款中, 14已退款(部分),
const getBgImg = (s, refundStatus) => {
  if (refundStatus) {
    switch (refundStatus) {
      case 5: // 5退票中 6：退票成功 7： 退票失败
        return os_ticketing_refundsucc_img;
      case 6: // 5退票中 6：退票成功 7： 退票失败
        return os_ticketing_refundsucc_img;
      case 7:
        return os_cancel_img;
    }
  }
  switch (s) {
    case 3:
    case 15:
      return os_needpay_img;
    case 4:
      return os_paysucc_img;
    case 5:
      return os_ticketing_img;
    case 6:
      return os_ticketsucc_img;
    case 7: // 出票失败，系统取消
      return os_cancel_img;
    case 8:
      return os_cancel_img;
    case 11:
    case 14:
      return os_cancel_img;
    case 9: // 退款
      return os_ticketing_refundsucc_img;
    case 10:
      return os_ticketing_refundsucc_img;
    case 12:
      return os_ticket_refundfailed_img;
    default:
      return '';
  }
};

const OrderStatus = (props) => {
  const [data, setData] = useState<any>(null);
  const [isMul, setIsMul] = useState(false);
  const [showTicketModal, setShowTickedModal] = useState(false);
  const [curTicketIndex, setCurTicketIndex] = useState(0);
  const [ticketCount, setTicketCount] = useState(0);
  const [hasQr, setHasQr] = useState(false);
  const [gray, setGray] = useState(false);
  const [showTips, setShowTips] = useState(false);
  const [tipsTitle, setTipsTitle] = useState('');
  const [tipsContent, setTipsContent] = useState('');
  const [sessionChangeDetail, setSessionChangeDetail] = useState('');
  const [showMessageChangeModal, setShowMessageChangeModal] = useState<boolean>(false);
  const { unionConfig } = props;
  const unionCode = unionFlag() || getSessonStorage('dffl_union');
  const CopyRef = useRef();
  const [val, setVal] = useState('');
  const CopyInput = useRef();
  useEffect(() => {
    const id = props.location.query.orderSn;

    homeReq.getLoginStatus2().then((res) => {
      Api.getOrderDetail(id).then((res) => {
        if (!res) return;
        setData(res);
        setSessionChangeDetail(res?.sessionChangeDetail);
        const isShow = res?.sessionChangeDetail && judgeTodayPopup(id) ? true : false;
        setShowMessageChangeModal(isShow);
        if(isShow) {
          gioClick('知道了', {
            pagename: currentPageName,
            modulename: '变更通知弹窗',
            elementname: '知道了'
          }, 'DF_exposureEvent');
        }
        sessionStorage.setItem('refundRuleExplain', JSON.stringify(res?.refundRuleExplain));
        if (res.seatList.length > 1) {
          setIsMul(true); // 多票价
        }
        /**
         * 9申请退款,10退款成功,13退款中,这三种状态的订单作置灰处理
         */
        if ([9, 10, 13].includes(res?.status)) {
          setGray(true);
        }
        // if (res.ticketQrCode) {
        //   setHasQr(true);
        // }
      });
    });
  }, []);
  const [countdownText, setCountdownText] = useState('');
  const [showCancelModal, setShowCancelModal] = useState(false);

  let status = !data || (data.status !== 3 && data.status !== 15);
  useInterval(
    () => {
      if (status) {
        return;
      }
      let t = distanceNow(data.endPayTime);
      setCountdownText(t);
      if (!t && (data.status === 3 || data.status === 15)) {
        setTimeout(() => {
          window.location.reload();
        }, 120000);
      }
    },
    status ? null : 1000,
  );

  const btnCancelHandle = () => {
    gioClick('取消订单', {
      pagename: currentPageName,
      modulename: '订单操作',
      elementname: '取消订单',
      status: '待支付',
      orderNum: data.orderSn
    });
    setShowCancelModal(true);
  };
  const toCancelOrderHandle = () => {
    setShowCancelModal(false);

    Api.getOrderCancel(data.orderSn).then((res) => {
      if (res) {
        Toast.info(TLang('取消订单成功', 'home', false, false, null));
        setTimeout(() => {
          window.location.reload();
        }, 2500);
      }
    });
  };
  const btnPayHandle = () => {
    if (data.paymentUrl) {
      setTimeout(() => {
        window.df_sdk_common.location.href =
          data.paymentUrl.indexOf('http') === 0 ? data.paymentUrl : '//' + data.paymentUrl;
      }, 1000);
    }
  };

  //const {top,headExtRender,is180,is195, navText,noticeText,bgImg,
  //movieImg,movieName,movieInfo,cinemaName,seatInfo,otherAlert,alert} = props;
  const ticketSuccEl = () => (
    <div className={styles.orderHeadExtWrapper}>
      <span className={styles.infoText}>{TLang('出票成功', 'home', false, false, null)}</span>
      {/* <span className={styles.succBtn} onClick={() => setShowTickedModal(true)}>
        取票凭证
      </span> */}
    </div>
  );
  const ticketingEl = () => (
    <div className={styles.orderHeadExtWrapper} style={{ top: 'inherit', display: 'initial' }}>
      <div>
        <span className={styles.infoText}>{TLang('出票中', 'home', false, false, null)}</span>
        <span className={styles.reloadButton} onClick={() => { window.location.reload(); }}>{TLang('刷新', 'home', false, false, null)}</span>
        {/* <a className={styles.reloadButton} href="#" onClick={() => {window.location.reload();}}>刷新</a> */}
      </div>
      <div>
        <span className={`${styles.timeText} ${styles.wrapText}`}>
          {data?.isVendor2 == 1 ?
            // TLang('预计30-60分钟出票，请耐心等待', 'home', false, false, null)
            TLang('抢票高峰，请耐心等待出票。', 'home', false, false, null)
            : (
              (CheckCN() ? data?.ticketTimeDesc : data?.ticketTimeDescEn)
              || TLang('预计1~3分钟会出票完成', 'home', false, false, null)
              )
          }
        </span>
      </div>
    </div>
  );
  const paySuccEl = () => (
    <div className={styles.orderHeadExtWrapper}>
      <span className={styles.infoText}>{TLang('已支付', 'home', false, false, null)}</span>
    </div>
  );
  const wattingPayEl = () => (
    <div className={styles.payHeadExtWrapper}>
      <span className={styles.infoText}>{TLang('待支付', 'home', false, false, null)}</span>
      <span className={`${styles.timeText}`}>
        {/* <i /> */}
        {/* {`请在${countdownText}内支付完成${TLang("已支付",'home',false,false,null)}`} */}
        {
          ReplaceText('X', countdownText, TLang('X', 'home', false, false, null), false)
        }
      </span>
    </div>
  );
  const cancelPayEl1 = (t) => (
    <div className={styles.payHeadExtWrapper}>
      <span className={styles.infoText}>{TLang('已取消', 'home', false, false, null)}</span>
      <span className={styles.timeText}>{t || TLang('系统取消原因', 'home', false, false, null)}</span>
    </div>
  );
  const cancelPayEl2 = () => (
    <div className={styles.orderHeadExtWrapper}>
      <span className={styles.infoText}>{TLang('已取消', 'home', false, false, null)}</span>
    </div>
  );
  const refundApply = () => (
    <div className={styles.orderHeadExtWrapper}>
      <span className={styles.infoText}>{TLang('申请退款', 'home', false, false, null)}</span>
    </div>
  );
  const refundSucc = () => (
    <div className={styles.orderHeadExtWrapper}>
      <span className={styles.infoText}>{TLang('退款成功', 'home', false, false, null)}</span>
    </div>
  );
  const refundCancel = () => (
    <div className={styles.orderHeadExtWrapper}>
      <span className={styles.infoText}>{TLang('已取消', 'home', false, false, null)}</span>
    </div>
  );
  const refundFailed = () => (
    <div className={styles.orderHeadExtWrapper}>
      <span className={styles.infoText}>{TLang('退款失败', 'home', false, false, null)}</span>
    </div>
  );
  const merchantRefund = () => (
    <div className={styles.orderHeadExtWrapper}>
      <span className={styles.infoText}>{TLang('退款中', 'home', false, false, null)}</span>
    </div>
  );
  const refundReason = (s, refundStatus) => (
    <div className={styles.payHeadExtWrapper}>
      <span className={styles.infoText}>{TLang(getGioStatusName(s, refundStatus), 'home', false, false, null)}</span>
      {data.refundFailReason && <span className={styles.timeText}>{data.refundFailReason}</span>}
    </div>
  );
  /**
3：待支付、4：已支付、5：出票中、6：出票成功、7：出票失败、
8：已取消（用户手动取消）、11：已取消（支付超时）、9：申请退款、10：退款成功、12：退款失败、14：部分退款、15：部分支付 13供应商退款中
 */
  const getTicketInfoEl = (s: number, refundStatus: number) => {
    if (refundStatus) {
      return refundReason(s, refundStatus);
    }
    switch (s) {
      case 3:
      case 15:
        return wattingPayEl();
      case 4:
        return paySuccEl();
      case 5:
        return ticketingEl();
      case 6:
        return ticketSuccEl();
      case 7:
        return cancelPayEl1(TLang('出票失败', 'home', false, false, null));
      case 11: // 出票失败，系统取消
        return cancelPayEl1(TLang('支付超时', 'home', false, false, null));
      case 8:
        return cancelPayEl2();
      case 9:
        return refundApply();
      case 10:
        return refundSucc();
      case 14:
        return refundCancel();
      case 12:
        return refundFailed();
      case 13:  //供应商退款中
        return merchantRefund();
      default:
        return <></>;
    }
  };
  // const rowFn=(prev)=> {
  //   let str='';
  //   for(let i=0;i<prev.length;i++) {
  //     if(prev[i].match(/\d+/)&&prev[i].match(/\d+/)[0]){
  //       if(prev[i+1].match(/\d+/)&&prev[i+1].match(/\d+/)[0]){
  //         str+=prev[i]+prev[i+1];
  //       }else{
  //         str+= prev[i];
  //       }
  //     }else{
  //       str+=TLang(prev[i], 'home', false, false, null);
  //     }
  //  }
  //   return str||'';
  // };
  const getSeatDesc = (arr): string => {
    let s: string = arr.reduce((prev, cur) => (prev += cur.seatDesc + ' '), '  ');
    return s || '';
  };
  const getUnit = () => {
    if (unionCode && typeof unionCode !== 'undefined') {
      return <span className="unit">({unionConfig.union_name || TLang('福豆', 'home', false, false, null)} )</span>;
    } else {
      return <span className="unit">({TLang('福豆', 'home', false, false, null)})</span>;
    }
  };
  // f 是否需要比例转换
  const getUnitAmount = (amount: number, f = false) => {
    if (amount && f && unionConfig?.union_scale) {
      let p = (amount / 100) * unionConfig.union_scale;
      return p.toFixed(2);
    } else {
      let p = amount / 100;
      return p.toFixed(2);
    }
  };
  const getPayWayDetailEl = (item: any, index: number, flag: boolean) => {
    if (item.payWay === 1 || item.refundWay === 1) {
      // 点卡
      return (
        <div className={styles.cell2} key={index}>
          <span>
            {flag ? `${ReplaceText('X', item.account, TLang('点卡[尾号X]支付', 'home', false, false, null), false)}`
              : `${ReplaceText('X', item.account, TLang('退回点卡[尾号X]支付', 'home', false, false, null), false)}`}
            {getUnit()}
          </span>
          <span>
            {flag ? `${getUnitAmount(item.amount * -1, true)}` : `${getUnitAmount(item.amount, true)}`}
          </span>
        </div>
      );
    } else if (item.payWay === 2 || item.refundWay === 2) {
      // 次卡
      return (
        <div className={styles.cell2} key={index}>
          <span>{flag ? `${ReplaceText('X', item.account, TLang('次卡[尾号X]支付', 'home', false, false, null), false)}`
            : `${ReplaceText('X', item.account, TLang('退回次卡[尾号X]支付', 'home', false, false, null), false)}`}</span>
          <span> {ReplaceText('X', item.amount, TLang('X次', 'home', false, false, null), false)}</span>
        </div>
      );
    }
    return (
      <div className={styles.cell2} key={index}>
        <span>{flag ? `${item?.payWayDesc}` : `${ReplaceText('X', item?.refundWayDesc, TLang('退回X', 'home', false, false, null), false)}`}</span>
        <span>{flag ? `${getUnitAmount(item.amount * -1, item.needConvert)}` : `${getUnitAmount(item.amount, item.needConvert)}`}</span>
      </div>
    );

  };
  const getPayWayTimeEl = (item: any, index: number, n: string) => {
    if (item.payWay === 1 || item.refundWay === 1) {
      // 点卡
      return (
        <div className={`${styles.cell2} ${styles.left}`} key={index}>
          <span>{`${ReplaceText('X', item.account, TLang('点卡[尾号X]', 'home', false, false, null), false)}${n}`}</span>
          <span>{item.payTime || item.refundTime}</span>
        </div>
      );
    } else if (item.payWay === 2 || item.refundWay === 2) {
      // 次卡
      return (
        <div className={`${styles.cell2} ${styles.left}`} key={index}>
          <span>{`${ReplaceText('X', item.account, TLang('次卡[尾号X]', 'home', false, false, null), false)}${n}`}</span>
          <span>{item.payTime || item.refundTime}</span>
        </div>
      );
    }
    //
    return (
      <div className={`${styles.cell2} ${styles.left}`} key={index}>
        <span>{`${item?.payWayDesc || item?.refundWayDesc}${n}`}</span>
        <span>{item.payTime || item.refundTime}</span>
      </div>
    );
  };

  const getGioStatusName = (s: number, refundStatus: number) => {
    if (refundStatus) {
      switch (refundStatus) {
        case 5:
          return '退票中';
        case 6:
          return '退票成功';
        case 7:
          return '退票失败';
      }
    }
    switch (s) {
      case 3:
      case 15:
        return '待支付';
      case 4:
        return '已支付';
      case 5:
        return '出票中';
      case 6:
        return '出票成功';
      case 7:
        return '已取消';
      case 11: // 出票失败，系统取消
        return '已取消';
      case 8:
        return '已取消';
      case 9:
        return '申请退款';
      case 10:
        return '退款成功';
      case 14:
        return '已取消';
      case 12:
        return '退款失败';
      case 13:  //供应商退款中
        return '退款中';
    }
  };

  const handleOpenService = () => {
    gioClick('点击联系客服', {
      pagename: currentPageName,
      status: getGioStatusName(data.status, data.refundStatus)
    });
    window.qimoChatClick();
  };


  const tipsMsg = (e) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();

    gioClick('立即支付', {
      pagename: currentPageName,
      modulename: '订单操作',
      elementname: '去支付',
      status: '待支付',
      orderNum: data.orderSn
    });

    if (!data?.showDateTime) {
      return '';
    }
    // 结束时间
    const lastTime = data?.showDateTime.replace(/-/g, '/').replace(/T/, ' ');
    const lastDate = new Date(lastTime);
    const nowDate = new Date();
    const dateDiff = lastDate.getTime() - nowDate.getTime();//时间差的毫秒数
    const minutes = Math.floor(dateDiff / (60 * 1000));//计算相差分钟数
    if (minutes <= 15) {
      let str;
      if (minutes > 0) {
        setTipsTitle(TLang('临近开场提醒', 'home', false, false, null));
        str = <div className={styles.tipsmsg}>{TLang('临近开场提醒：您选购的场次将在', 'home', false, false, null)}
          <span>
            {ReplaceText('X', minutes, TLang('X分钟内', 'home', false, false, null), false)}
          </span>{TLang('开场，临近开场场次出票时间较长且出票失败率高，建议选购下个场次', 'home', false, false, null)}</div>;
      } else {
        setTipsTitle(TLang('已开场提醒', 'home', false, false, null));
        str = <div className={styles.tipsmsg}>{TLang('已开场提醒：您选购的场次', 'home', false, false, null)}<span>{TLang('已开场', 'home', false, false, null)}</span>，

          {TLang('继续购票可能出票时间较长且出票失败率高，建议选购下个场次', 'home', false, false, null)}
        </div>;
      }
      setShowTips(true);
      setTipsContent(str);
    } else {
      setShowTips(false);
      setTipsContent('');
      btnPayHandle(e);

    }
  };
  const copyOrderNoFn = () => {
    let text = CopyRef.current.innerText;
    CopyInput.current.innerText = text;
    setVal(text);
    CopyInput.current && CopyInput.current.select();
    try {
      if (document.execCommand('Copy')) {
        Toast.show(TLang('复制成功', 'home', false, false, null));
      } else {
        Toast.show(TLang('复制失败', 'home', false, false, null));
      }
    } catch (err) {
      Toast.show(TLang('复制失败', 'home', false, false, null));
    }
  };

  // 退票
  const refundClick = () => {
    Api.goToRefundApplyPage({ orderSn: data.orderSn }).then((res) => {
      if (res) {
        sessionStorage.setItem('refundDetail', JSON.stringify(res));
        router.push({
          pathname: '/applyRefund'
        });
      }
    });
  };


  /**跳到小食活动页 */
  const gotoSnackClick = (info: any) => {
    const union = unionFlag() || sessionStorage.getItem('dffl_union') || sessionStorage.getItem('film_dffl_union');
    if (union || checkUnifyShop()){
      window.df_sdk_common.location.href = info?.hrefBfdH5;
    } else {
      window.df_sdk_common.location.href = info?.hrefGWH5;
    }
  };


  return (
    <div className={`${styles.orderWrapper} bottom-button`}>
      {data ? (
        <OrderHead
          is195
          top
          fixedBottom={data.status === 2}
          navText={TLang('订单详情', 'home', false, false, null)}
          noticeText={data.cinemaNotice}
          movieImg={data.movieLogo}
          movieName={data.movieName}
          movieInfo={getMovieSessionInfoStr(data)}
          cinemaName={data.cinemaName}
          ticketChangeDesc={data?.ticketChangeDesc}
          supportChange={data?.supportChange}
          supportRefund={data?.supportRefund}
          isVendor2={data?.isVendor2}
          // TODO:是否可以退换的字段由接口提供
          alert={data?.refundDesc}
          // alert={'不可退换'}
          // alert={data.movieAlert}
          headExtRender={getTicketInfoEl(data.status, data.refundStatus)}
          bgImg={getBgImg(data.status, data.refundStatus)}
        >
          {
          data?.snackFeature?.snackPage?.imgH5 ? (
            <div className={styles.orderMainsNackFeature} onClick={() => gotoSnackClick(data?.snackFeature?.snackPage)}>
              <img style={styles.orderMainsNackFeature_img} src={data?.snackFeature?.snackPage?.imgH5} alt=""/>
            </div>) : null
          }
          {sessionChangeDetail && <div className={styles.movieDetailMoneyWrap}>
            <div className={styles.changeNotice}>
              {sessionChangeDetail}
            </div>
          </div>}
          <div className={styles.orderMainInfoWrapper}>
            {data && isMul ? (
              <div className={styles.seatWrapper}>
                <div className={styles.hallName}>{data.hallName}</div>
                <div className={styles.seats}>
                  {data.seatList.map((itemArr, index) => (
                    <div className={styles.cell0} key={index}>
                      <span className={styles.hallName}>{getSeatDesc(itemArr)}</span>
                      <DfPrice
                        price={itemArr[0].price}
                        showIcon={false}
                        showUnit
                        textStyles={{ fontSize: '0.24rem', fontWeight: 400, color: '#333' }}
                      >
                        <span>x{itemArr.length}</span>
                      </DfPrice>

                      {/* <span>{toPrice(itemArr[0].price)}<span className="unit">福豆</span>x{itemArr.length}</span> */}
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <div className={styles.cell}>
                <span className={styles.seatDesc}>
                  {data.hallName}
                  {getSeatDesc(data.seatList[0])}
                  {/* {ReplaceText("X",discount,TLang("X折",'home',false,false,null),false)} */}
                </span>
                <DfPrice
                  price={data.seatList[0][0].price}
                  showIcon={false}
                  showUnit
                  textStyles={{ fontSize: '0.24rem', fontWeight: 400, color: '#333' }}
                >
                  <span style={{ marginLeft: '0px' }}>x{data.seatList[0].length}</span>
                </DfPrice>

                {/* <span>{toPrice(data.seatList[0][0].price)}<span className="unit">福豆</span>x{data.seatList[0].length}</span> */}
              </div>
            )}
            <div className={styles.cell}>
              <span>{TLang('取票手机号', 'home', false, false, null)}</span>
              <span>{data.mobile}</span>
            </div>
            {
              [6, 9, 10, 12, 13].includes(data.status) &&
              <div className={styles.codeWrap}>
                {
                  data.ticketQrCode ? <div className={styles.tips}>{TLang('请凭二维码或取票码至影院取票', 'home', false, false, null)}</div> : <div className={styles.tips}>
                    {TLang('请凭取票码至影院取票', 'home', false, false, null)}</div>
                }

                {
                  data.ticketQrCode && <div className={`${styles.qrCodeBox} ${gray || data.refundStatus == 5 ? styles.gray : ''}`}>
                    <QRCode
                      value={data.ticketQrCode}
                      size={120}
                      fgColor="#000000"
                    />
                  </div>
                }
                <div className={styles.ticketAmount}>
                  {ReplaceText('X', data.num, TLang('内含X张', 'home', false, false, null), false)}
                </div>
                <div className={styles.codeBox}>
                  <span className={`${styles.desc} ${gray || data.refundStatus == 5 ? styles.gray : ''}`}>{TLang('取票码', 'home', false, false, null)}</span>
                  <span className={`${styles.ticketCode} ${gray || data.refundStatus == 5 ? styles.gray : ''} ${data.refundStatus == 6 || data.refundStatus == 5 ? styles.textLineThrough : ''}`}>{data.ticketCode}</span>
                  {data.refundStatus == 6 && <img src={getCookie('df_lang') === 'en-US' ? refundTagsEn : refundTags} alt="" />}
                </div>
              </div>
            }
          </div>
          <div className={styles.movieDetailMoneyWrap}>
            <div className={styles.moneyCell}>
              <span>{TLang('商品总价', 'home', false, false, null)}</span>
              <DfPrice
                price={data.originAmount || data.totalPrice}
                showIcon={false}
                iconCls="xl"
                textStyles={{ fontSize: '0.28rem', fontWeight: 400, color: '#333' }}
              />
            </div>
            {data?.payServiceFee > 0 && (<div className={styles.moneyCell}>
              <span>{TLang('平台服务费', 'home', false, false, null)}</span>
              <DfPrice
                price={data.payServiceFee}
                showIcon={false}
                iconCls="xl"
                textStyles={{ fontSize: '0.28rem', fontWeight: 400, color: '#333' }}
              />
            </div>)}
            <div className={styles.totalCell}>
              <span>{TLang('合计', 'home', false, false, null)}</span>
              <DfPrice
                price={data.totalPrice}
                iconCls="xl"
                textStyles={{ fontSize: '0.32rem', fontWeight: 500, color: '#FF5757' }}
              />
              {/* <span className={styles.price}>{toPrice(data.totalPrice)}</span> */}
            </div>
          </div>
          {/**
3：待支付、4：已支付、5：出票中、6：出票成功、7：出票失败、
8：已取消（用户手动取消）、11：已取消（支付超时）、9：申请退款、10：退款成功、12：退款失败、14：部分退款
 */
            data.status === 4 ||
              data.status == 5 ||
              data.status == 6 ||
              data.status == 7 ||
              data.status == 9 ||
              data.status == 10 ||
              data.status == 12 ||
              data.status == 14 ? (
                <div className={styles.payDescWrapper}>
                  <div className={styles.cell2}>
                    <span className={styles.paydesctitle}>{TLang('支付明细', 'home', false, false, null)}</span>
                    <span></span>
                  </div>
                  {data.paymentInfos &&
                  data.paymentInfos.map((item: any, index: number) =>
                    getPayWayDetailEl(item, index, true),
                  )}
                </div>
            ) : null}
          {data.status == 7 || data.status == 10 || data.status == 14 ? (
            <div className={`${styles.payDescWrapper} ${styles.payDescWrapper_2}`}>
              <div className={styles.cell2}>
                <span className={styles.paydesctitle}>{TLang('退款明细', 'home', false, false, null)}</span>
                <span></span>
              </div>
              {data.refundInfos &&
                data.refundInfos.map((item: any, index: number) =>
                  getPayWayDetailEl(item, index, false),
                )}
            </div>
          ) : null}
          <div className={styles.orderDescWrapper}>
            {data?.orderSn && (
              <>
                <div className={`${styles.cell2} ${styles.left} ${styles.orderdesc}`}>
                  <span>{TLang('订单号', 'home', false, false, null)}：</span>
                  {/* <textarea ref={CopyInput} disabled className={styles.inputTextarea} style={{  position:'fixed', top:600, left: 0, opacity: 0, zIndex: -10, pointerEvents:'none'}}></textarea> */}
                  <span ref={CopyRef}>{data.orderSn}</span>
                  {/* <span style={{width:'40px', height:'16px', textAlign:'center', lineHeight:'16px', borderRadius:'16px', display:'inline-block', marginLeft:'8px', marginBottom:'4px',
  background:'#F5F5F5', color: '#333333', fontWeight: 400, fontSize:'12px'}}  onClick={() => {copyOrderNoFn();}}
                  >{TLang('复制', 'home', false, false, null)}</span> */}
                  <CopyToClipboard text={data.orderSn} onCopy={() => {
                    Toast.show(TLang('复制成功', 'home', false, false, null));
                  }}
                  >
                    <span style={{
                      width: '40px', textAlign: 'center', borderRadius: '16px', display: 'inline-block', marginLeft: '8px',
                      background: '#F5F5F5', color: '#333333', fontWeight: 400, fontSize: '12px'
                    }}
                    >{TLang('复制', 'home', false, false, null)}</span>
                  </CopyToClipboard>
                </div>
                <div className={`${styles.cell2} ${styles.left} ${styles.orderdesc}`}>
                  <span>{TLang('创建时间', 'home', false, false, null)}:</span>
                  <span>{data.createdTime}</span>
                </div>
              </>
            )}



          </div>
          {data.status === 4 ||
            data.status === 5 ||
            data.status === 6 ||
            data.status === 7 ||
            data.status == 9 ||
            data.status == 10 ||
            data.status == 12 ||
            data.status == 14 ? (
              <div className={styles.payTimeDescWrapper}>
                {data.paymentInfos &&
                data.paymentInfos.map((item, index) => getPayWayTimeEl(item, index, TLang('付款时间', 'home', false, false, null)))}
              </div>
          ) : null}
          {data.status === 7 || data.status == 10 || data.status == 14 ? (
            <div className={styles.payTimeDescWrapper}>
              {data.refundInfos &&
                data.refundInfos.map((item, index) => getPayWayTimeEl(item, index, TLang('最新退款时间', 'home', false, false, null)))}
            </div>
          ) : null}
          {data.status === 3 && countdownText ? (
            <div className={`${styles.bottomWrapper}`}>
              <div className={styles.priceWrapper}>
                <span>{TLang('需支付', 'home', false, false, null)}</span>
                <DfPrice
                  price={data.totalPrice}
                  iconCls="xl"
                  textStyles={{ fontSize: '0.36rem', fontWeight: 500, color: '#F44545' }}
                />

                {/* <b/>
                  <span>{toPrice(data.totalPrice)}</span> */}
              </div>
              <div className={styles.btnsWrapper}>
                <div onClick={() => btnCancelHandle()}>{TLang('取消支付', 'home', false, false, null)}</div>
                <div onClick={(e) => tipsMsg(e)}>{TLang('立即支付', 'home', false, false, null)}</div>
              </div>
            </div>
          ) : null}
        </OrderHead>
      ) : null}
      <div
        onClick={() => { handleOpenService(); }}
        style={{ position: 'fixed', right: '11px', bottom: '100px', width: '54px', height: '54px' }}
      >
        <img src={CheckCN() ? serviceIcon : text_serviceen} style={{ width: '100%' }} />
      </div>
      {
        data?.showApplyRefundButton && <div className={`${styles.applyRefundButton} `}>
          <div className={styles.applyRefundButton_content}>
            <div className={styles.applyRefundButton_left}>
              <span>{TLang(data?.refundButtonDesc, 'home', false, false, null)}</span>
              {data?.clickableApplyRefundButton && <span onClick={() => window.df_sdk_common.location.href = window.location.origin + '/newmovie/refundExplain'}>{TLang('退票规则', 'home', false, false, null)}<img src={refundRightArrow} /></span>}
            </div>
            <Button onClick={debounce(refundClick, 500)} disabled={!data?.clickableApplyRefundButton} className={`${styles.applyRefundButton_right} ${getCookie('df_lang') === 'en-US' ? styles.applyRefundButton_right_en : ''}`}>
              {TLang('申请退票', 'home', false, false, null)}
            </Button>
          </div>
        </div>
      }
      <Modal
        className="ticketModal"
        visible={showTicketModal}
        transparent
        maskClosable={false}
        onClose={() => setShowTickedModal(false)}
      >
        {data ? (
          <div className="ticketModalWrapper">
            <div className="headWrapper">
              <div className="title">
                <span>{TLang('取票凭证', 'home', false, false, null)}</span>
              </div>
              <div className="noti">
                {hasQr ? TLang('请凭二维码或取票码至影院取票', 'home', false, false, null) : TLang('请凭取票码至影院取票', 'home', false, false, null)}
              </div>
              <i className="line" />
              <img
                className="close"
                onClick={() => setShowTickedModal(false)}
                src={closeimg}
                alt="x"
              />
            </div>
            <div className="contentWrapper">
              {hasQr ? (
                <div className="qrWrapper">
                  <img className="qr" src={data.ticketQrCode} alt="" />
                </div>
              ) : (
                <div className="qrWrapper qrCodeWrapper codeWrapper">
                  <span>{TLang('取票码', 'home', false, false, null)}</span>
                  <span>{data.ticketCode}</span>
                </div>
              )}

              <p className={`${hasQr ? 'qrinfo' : 'qrinfo noQrInfo'}`}>{ReplaceText('X', data.num, TLang('内含X张', 'home', false, false, null), false)}</p>
              {hasQr ? (
                <div className="qrCodeWrapper">
                  <span>{TLang('取票码', 'home', false, false, null)}</span>
                  <span>{data.ticketCode}</span>
                </div>
              ) : null}
            </div>
          </div>
        ) : null}
      </Modal>
      <DfModal
        show={showCancelModal}
        // img={cancelImg}
        desc={TLang('您确认要取消该订单吗', 'home', false, false, null)}
        left={{ text: TLang('暂不取消', 'home', false, false, null), action: () => setShowCancelModal(false) }}
        right={{ text: TLang('确定取消', 'home', false, false, null), action: () => toCancelOrderHandle() }}
      />
      <Modal
        visible={showTips}
        transparent
        maskClosable
        title={tipsTitle}
        className="confirm-info-modal"
        wrapClassName="conform-wrap"
      >
        <div className="content">
          <div className="desc">
            {tipsContent}
          </div>
          <div className="footer">
            <div className="cancle" onClick={(e) => {
              e.stopPropagation();
              e.nativeEvent.stopImmediatePropagation();
              setShowTips(false);
            }}
            >{TLang('返回', 'home', false, false, null)}</div>
            <div className="confirm" onClick={btnPayHandle}>{TLang('继续支付', 'home', false, false, null)}</div>
          </div>
        </div>
      </Modal>
      <Modal
        visible={showMessageChangeModal}
        transparent
        maskClosable
        title="变更通知"
        className="confirm-info-modal"
        wrapClassName="conform-wrap"
      >
        <div className="content">
          <div className="desc">
            {sessionChangeDetail}
          </div>
          <div className="footer" onClick={() => {
            gioClick('知道了', {
              pagename: currentPageName,
              modulename: '变更通知弹窗',
              elementname: '知道了'
            });
            setShowMessageChangeModal(false);
          }}
          >
            <div className="confirm">{TLang('知道了', 'home', false, false, null)}</div>
          </div>
        </div>
      </Modal>
    </div>
  );
};
const mapStateToProps = ({ initData }) => ({ unionConfig: initData.unionConfig });
export default withRouter(connect(mapStateToProps)(OrderStatus));
